// Отворена/свита група в менюто („Операции" под „Табло") — СВИТА по
// подразбиране (от таблото всяка операция е на един клик или клавиш 1–8) и
// изборът се ПОМНИ между посещенията в localStorage, по модул и по група — както
// `useSidebarCollapse` помни самото меню. Изборът е един за всички екрани: групата
// е въпрос на съдържание, не на ширина.
//
// Всяко четене/писане е в try/catch: без хранилище (частен прозорец, пълна
// квота, забранени данни) групата работи — само не помни. Записът чете наново и
// слива само своята група, за да не затрие избора от друг таб.
import { useCallback, useState } from "react";

export type NavGroupChoices = Record<string, boolean>;

export const navGroupStorageKey = (module: string) => `sidebar_groups_open:${module}`;

export const readNavGroupChoices = (module: string): NavGroupChoices => {
  try {
    const raw = localStorage.getItem(navGroupStorageKey(module));
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};
    const choices: NavGroupChoices = {};
    for (const [group, value] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof value === "boolean") choices[group] = value;
    }
    return choices;
  } catch {
    return {};
  }
};

export const writeNavGroupChoice = (module: string, group: string, open: boolean) => {
  try {
    const next = { ...readNavGroupChoices(module), [group]: open };
    localStorage.setItem(navGroupStorageKey(module), JSON.stringify(next));
  } catch {
    // без хранилище групата просто не помни — изборът важи до края на посещението
  }
};

export const useNavGroupOpen = (module: string, group: string) => {
  const [open, setOpen] = useState<boolean>(
    () => readNavGroupChoices(module)[group] ?? false,
  );
  const toggle = useCallback(() => {
    const next = !open;
    setOpen(next);
    writeNavGroupChoice(module, group, next);
  }, [open, module, group]);
  return { open, toggle };
};
